import { ResultCode } from '../shared/model/attributes/resultcode';
import { PayResponse } from '../shared/model/payresponse';
import { ControllerService } from '../shared/service/controller.service';
import { Component, OnInit } from '@angular/core';
import { PaymentService } from '../shared/service/payment.service';
import { ActivatedRoute, Router } from '@angular/router';
import AdyenCheckout from '@adyen/adyen-web';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-step4-dropin-result',
  templateUrl: './step4-dropin-result.component.html',
  styleUrls: ['./step4-dropin-result.component.css']
})
export class Step4DropinResultComponent implements OnInit {

  title: string;
  description: string;
  refusalReason: string;
  payResponse: PayResponse;
  reasonAvailable: string;
  link: string;
  transParam: Object;
  step = 'step4';
  private redirectSessionId: string;
  private redirectResult: string;
  private resultCode: ResultCode;
  private stateResultCode: string;
  hasError: boolean;


  constructor(private router: Router, private route: ActivatedRoute, private controller: ControllerService, private paymentService: PaymentService) {
    this.link = this.controller.getLink();
    const name = localStorage.getItem('name');
    this.transParam = {
      name: name ? name : 'donateur'
    };
    this.redirectSessionId = this.route.snapshot.queryParamMap.get('sessionId');
    this.redirectResult = this.route.snapshot.queryParamMap.get('redirectResult');
    this.stateResultCode = this.route.snapshot.queryParamMap.get('stateResultCode');
  }

  ngOnInit() {
    this.handleRedirect();
  }

  async handleRedirect() {
    // Redirect from banking
    if (this.redirectSessionId && this.redirectResult){
      const configuration = this.buildDropinConfiguration();

      const checkout = await AdyenCheckout(configuration);
      checkout.submitDetails({details: {redirectResult: this.redirectResult}});
    } else if (this.stateResultCode) {
      // Redirect from dropin
      this.handleResultCode(ResultCode.fromValue(this.stateResultCode), null);
    }
  }

  private handleResult(state) {
    this.resultCode = ResultCode.fromValue(state.resultCode);

    if (this.resultCode != null) {
      this.handleResultCode(ResultCode.fromValue(state.resultCode), state.refusalReason);
    }
  }

  private handleResultCode(resultCode, refusalReason) {
    if (ResultCode.AUTHORISED === resultCode ||
      ResultCode.RECEIVED === resultCode ||
      ResultCode.PENDING === resultCode) {
      this.title = 'result.payment.thanks';
      this.description = 'result.payment.thanks_desc';
      this.refusalReason = null;
    } else if (ResultCode.CANCELLED === resultCode) {
      this.title = 'result.payment.cancelled';
      this.description = 'result.payment.cancelled_desc';
    } else if (ResultCode.ERROR === resultCode || ResultCode.REFUSED === resultCode) {
      this.title = 'result.payment.refused';
      this.description = 'result.payment.refused_desc';
      if (refusalReason != null) {
        this.reasonAvailable = 'result.payment.reason';
      }
    }
    if (refusalReason) {
      this.refusalReason = refusalReason;
    }
  }

  private buildDropinConfiguration() {
    const configuration = {
      clientKey: environment.ADYEN_CLIENT_KEY,
      locale: this.controller.locale,
      environment: environment.ADYEN_ENV,
      session: {
        id: this.redirectSessionId
      },
      // Only called for payments without redirect, such as creditcards
      onPaymentCompleted: (state: any) => {
        this.handleResult(state);
      },
      onError: (error: any, component: any) => {
        this.showError(error.name, error.message, error.stack, component);
      }
    };

    // Only needed for test. This will be automatically retrieved when you are in production.
    if (!environment.production) {
      configuration['countryCode'] = 'NL'
    }

    return configuration;
  }

  private showError(...errors: any) {
    console.error(errors);
    this.hasError = true;
  }
}
